import React from 'react';
import T from '@prisjakt/ui-translate';

import * as S from './styles';

import { ProductCorePropertiesTableProps } from './types';

const getBooleanValue = (value: string) => (
  <T domain="product">
    {`property.boolean-${value === 'true' || value !== 'false' ? 'yes' : 'no'}`}
  </T>
);

const ProductCorePropertiesTable = ({
  className,
  properties,
  toneDown,
  maxrows,
  size,
}: ProductCorePropertiesTableProps) => (
  <S.PropertyTable
    className={className}
    toneDown={toneDown}
    maxRows={maxrows}
    size={size}
  >
    <S.TableBody>
      {properties ? (
        properties.map(({ type, name, prettyTable }, index) =>
          prettyTable !== null ? (
            <S.TableRow key={`${name}-${index.toString()}`}>
              <S.TableHeader scope="row">{name}</S.TableHeader>
              <S.TableCell>
                {type !== 'boolean'
                  ? prettyTable
                  : getBooleanValue(prettyTable)}
              </S.TableCell>
            </S.TableRow>
          ) : null
        )
      ) : (
        <S.TableRow>
          <S.TableCell>
            <S.PlaceholderProperty as="div" toneDown={toneDown} size={size} />
          </S.TableCell>
        </S.TableRow>
      )}
    </S.TableBody>
  </S.PropertyTable>
);

ProductCorePropertiesTable.defaultProps = {
  properties: undefined,
  toneDown: false,
  maxrows: undefined,
  size: 'large',
  className: undefined,
};

export default ProductCorePropertiesTable;
